import { render, staticRenderFns } from "./ShiftPointsTable.vue?vue&type=template&id=59b30bda&scoped=true&"
import script from "./ShiftPointsTable.vue?vue&type=script&lang=js&"
export * from "./ShiftPointsTable.vue?vue&type=script&lang=js&"
import style0 from "./ShiftPointsTable.vue?vue&type=style&index=0&id=59b30bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b30bda",
  null
  
)

export default component.exports